export const EVENT_BUS_CONTEXT = 'api'
export const EVENT_BUS_TARGET = 'error'
export const REQUEST_TIMEOUT_MS = 10000
